<dx-tab-panel [swipeEnabled]="false">
  <dxi-item
    title="{{ 'homePage.labels.notifs' | translate }}"
    [badge]="unseenNotifCount > 0 ? ' ' : ''"
  >
    <div class="d-flex flex-column align-items-stretch" style="height: 380px">
      <div
        class="h-0 flex-grow-1 overflow-y-auto"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        (scrolled)="onNotifsScroll()"
      >
        <div *ngIf="notifications.count === 0">
          <div class="text-center text-muted mt-5">
            {{ "homePage.messages.noNotifications" | translate }}
          </div>
        </div>
        <div
          class="m-2 mx-3 mb-4"
          [ngClass]="!notif.seen ? 'unseen-item' : ''"
          *ngFor="let notif of sortedNotifications"
        >
          <div
            class="d-flex align-items-center cursor-pointer"
            [ngClass]="notif.seen ? 'text-muted opacity-50' : ''"
          >
            <h6 class="fw-bold m-0 mb-2" (click)="openNotification(notif)">
              {{ notif.title }}
            </h6>
            <div class="mr-auto d-flex">
              <button
                class="notif-action border-0 d-block"
                type="button"
                (click)="deleteNotification(notif)"
              >
                <ng-icon name="lucideTrash2" class="text-dark"></ng-icon>
              </button>
              <div class="ms-1"></div>
              <button
                class="notif-action border-0 d-block"
                type="button"
                (click)="markNotificationSeen(notif)"
                *ngIf="!notif.seen"
              >
                <ng-icon
                  name="lucideCheckCheck"
                  [ngClass]="notif.seen ? 'text-success' : 'text-dark'"
                ></ng-icon>
              </button>
            </div>
          </div>
          <div
            class="text-muted line-4 align-text-justify"
            [ngClass]="notif.seen ? 'text-muted opacity-50' : ''"
          >
            {{ notif.message }}
          </div>
          <div
            class="text-muted fs-6 mt-1"
            [ngClass]="notif.seen ? 'text-muted opacity-50' : ''"
          >
            {{ notif.create_time | stringToDate | dateToJalali }}
          </div>
        </div>
      </div>
      <div class="border-top"></div>
      <div class="d-flex align-content-center btn-group mx-2 mt-1">
        <div class="d-flex align-items-center">
          <span class="text-muted"> خوانده نشده:</span>
          <b> {{ unseenNotifCount }} &nbsp; </b>
          <span class="text-muted"> تعداد: </span>
          <b>
            {{ notifications.count }}
          </b>
        </div>
        <div class="mr-auto">
          <button
            class="notif-action"
            type="button"
            (click)="deleteAllNotifications()"
          >
            <ng-icon name="lucideTrash2" class="text-dark"></ng-icon>
          </button>
          <button
            class="notif-action ms-1"
            type="button"
            (click)="seeAllNotifications()"
          >
            <ng-icon name="lucideCheckCheck" class="text-dark"></ng-icon>
          </button>
        </div>
      </div>
    </div>
  </dxi-item>
  <dxi-item
    title="{{ 'homePage.labels.messages' | translate }}"
    [badge]="unseenMessageCount > 0 ? ' ' : ''"
  >
    <div class="d-flex flex-column align-items-stretch" style="height: 380px">
      <div
        class="h-0 flex-grow-1 overflow-y-auto"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        (scrolled)="onMessagesScroll()"
      >
        <div *ngIf="messages.count === 0">
          <div class="text-center text-muted mt-5">
            {{ "homePage.messages.noMessages" | translate }}
          </div>
        </div>
        <div
          class="m-2 mx-3 mb-4"
          [ngClass]="!message.seen ? 'unseen-item' : ''"
          *ngFor="let message of sortedMessages"
        >
          <div class="d-flex align-items-center cursor-pointer">
            <h6
              class="fw-bold m-0 mb-2"
              (click)="openMessage(message)"
              [ngClass]="message.seen ? 'text-muted opacity-50' : ''"
            >
              {{ message.title }}
            </h6>
            <div class="mr-auto d-flex">
              <button
                class="notif-action border-0 d-block"
                type="button"
                (click)="deleteMessage(message)"
              >
                <ng-icon name="lucideTrash2" class="text-dark"></ng-icon>
              </button>
              <div class="ms-1"></div>
              <button
                class="notif-action border-0 d-block"
                type="button"
                (click)="markMessageAsSeen(message)"
                *ngIf="!message.seen"
              >
                <ng-icon
                  name="lucideCheckCheck"
                  [ngClass]="message.seen ? 'text-success' : 'text-dark'"
                ></ng-icon>
              </button>
            </div>
          </div>
          <div
            class="text-muted line-4 align-text-justify"
            [ngClass]="message.seen ? 'text-muted opacity-50' : ''"
          >
            {{ message.body | extractHtmlText }}
          </div>
          <div
            class="text-muted fs-6 mt-1"
            [ngClass]="message.seen ? 'text-muted opacity-50' : ''"
          >
            {{ message.create_time | stringToDate | dateToJalali }}
          </div>
        </div>
      </div>
      <div class="border-top"></div>
      <div class="d-flex align-content-center btn-group mx-2 mt-1">
        <div class="d-flex align-items-center">
          <span class="text-muted"> خوانده نشده:</span>
          {{ unseenMessageCount }} &nbsp;
          <span class="text-muted"> تعداد: </span>
          {{ messages.count }}
        </div>
        <div class="mr-auto">
          <button
            class="notif-action"
            type="button"
            (click)="deleteAllMessages()"
          >
            <ng-icon name="lucideTrash2" class="text-dark"></ng-icon>
          </button>
          <button
            class="notif-action ms-1"
            type="button"
            (click)="seeAllMessages()"
          >
            <ng-icon name="lucideCheckCheck" class="text-dark"></ng-icon>
          </button>
        </div>
      </div>
    </div>
  </dxi-item>
</dx-tab-panel>
